import { useMemo, useState } from 'react';

import { Highcharts } from '@/lib/highcharts';

import type { ChartsBlockTabType, TemplateChartSeries } from '../types';

const indicatorTitles = new Map([
  ['bb', 'Bollinger Bands'],
  ['linearRegression', 'Linear Regression'],
  ['linearRegressionAngle', 'Linear Regression Angle'],
  ['linearRegressionIntercept', 'Linear Regression Intercept'],
  ['linearRegressionSlope', 'Linear Regression Slope'],
  ['apo', 'Absolute Price'],
  ['atr', 'Average True Range'],
  ['natr', 'NATR']
]);

(function (H: any) {
  const seriesTypes: any = H.seriesTypes;
  for (const [key, value] of Object.entries(seriesTypes)) {
    const title = indicatorTitles.get(key);
    const type: any = value;
    if (title) {
      type.prototype.nameBase = title;
    }
  }
})(Highcharts);

const useMarketsChart = <T>(tab: ChartsBlockTabType<T>) => {
  const [activeTab, setActiveTab] = useState(0);

  const metadata = tab.metadata;

  const templateChartSeries: TemplateChartSeries[] = useMemo(() => {
    return tab.series;
  }, [activeTab, tab]);

  return {
    activeTab,
    setActiveTab,
    templateChartSeries,
    metadata
  };
};

export default useMarketsChart;
